import { X, Search, CreditCard, Download, FolderPlus, Upload, Wand2, Rocket } from "lucide-react";

const STEPS = [
  { icon: Search, title: "Browse & pick a startup", desc: "Explore the marketplace and choose the ready-to-build startup you want to launch." },
  { icon: CreditCard, title: "Purchase it", desc: "Complete a one-time secure checkout to unlock the project." },
  { icon: Download, title: "Download your build file", desc: "Instantly receive the project package \u2014 the exact build file for this app." },
  { icon: FolderPlus, title: "Open your AI builder & start a new project", desc: "Head to your AI builder and create a fresh project." },
  { icon: Upload, title: "Upload the file", desc: "Drop the downloaded build file into your AI builder to import it." },
  { icon: Wand2, title: "Your builder rebuilds the exact app", desc: "Your AI builder recreates the exact app you saw \u2014 fully working and ready." },
  { icon: Rocket, title: "Customize & launch", desc: "Tweak branding, features and AI, then launch your own company." },
];

export const HowItWorksModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={onClose}
      data-testid="how-it-works-modal"
    >
      <div
        className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl border border-gray-100 max-h-[85vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#F5F5F5] hover:bg-[#EAEAEA] flex items-center justify-center text-[#687280] transition-colors"
          data-testid="how-it-works-close"
        >
          <X size={16} />
        </button>

        <div className="p-6">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37]/12 px-3 py-1 text-[11px] font-bold text-[#B8901F] mb-3">
            How It Works
          </div>
          <h2 className="font-display text-2xl font-extrabold text-[#0F0F0F] tracking-tight">
            From marketplace to your own app
          </h2>
          <p className="text-sm text-[#687280] mt-1.5 leading-relaxed">
            Every startup is already built and ready. Here's exactly how you get the build file and recreate the app you see.
          </p>

          <ol className="mt-5 space-y-3">
            {STEPS.map((s, i) => (
              <li key={s.title} className="flex gap-3" data-testid={`hiw-step-${i + 1}`}>
                <div className="relative shrink-0">
                  <div className="w-9 h-9 rounded-xl bg-[#0F0F0F] text-[#D4AF37] flex items-center justify-center">
                    <s.icon size={17} />
                  </div>
                  {i < STEPS.length - 1 && (
                    <span className="absolute left-1/2 -translate-x-1/2 top-9 h-3 w-px bg-gray-200" />
                  )}
                </div>
                <div className="pb-1">
                  <p className="text-sm font-bold text-[#0F0F0F]">
                    <span className="text-[#B8901F]">{i + 1}.</span> {s.title}
                  </p>
                  <p className="text-xs text-[#687280] mt-0.5 leading-relaxed">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <button
            onClick={onClose}
            className="mt-6 w-full bg-[#0F0F0F] text-white rounded-full py-3 text-sm font-bold hover:bg-[#1c1c1c] transition-colors"
            data-testid="how-it-works-close-btn"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
